import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from '../../services/users.service';


@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent {
    get isAuthorized(): boolean {
        return this.usersService.currentUser !== null;
    }

    constructor(
        private usersService: UsersService,
        private router: Router) { }

    logout(): void {
        this.usersService.logout();
        this.router.navigate(['/welcome']);
    }
}